/*
 * ログイン画面定義用コンポーネント
 * 共通部品
 */
<template>
	<div>
		<!-- <title>{{r_messages.title}}</title> -->
	</div>
</template>
<script>
export default {
	mixins: [
		require('js/common/url.mixin.vue'),
		require('js/common/vuex/manager/read.mixin.vue'),
	],
	props:[
		'r_settings',
		'r_messages',
	],
	data: function(){
		return {
		};
	},
	computed:{
	},
	mounted: function(){
		var target = this;
		this.$nextTick(function(){
			// ユーザーIDにフォーカスを設定
			document.getElementById('user_id').focus();
		});
	},
	methods: {
		//! 初期化イベント
		onInitialize: function(){

		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts/login/Body.vue